import * as angular from 'angular';

(() => {
    'use strict';

    /**
     * @ngdoc component
     * @name pkpMarketMessage
     * @memberof app
     *
     * @description
     * Component shows one market message
     *
     * @author somarten.btc
     */
    angular.module('app').component('pkpMarketMessage', {
        template: require('app/_directives/pkp-market-message.component.html'),
        controller: PkpMarketMessageCtrl,
        bindings: {
            message: '<?'
        }
    });

    function PkpMarketMessageCtrl(DATES) {
        var vm = this;

        vm.DATES = DATES;
        vm.marketMessage = vm.message;
    }
})();
